<template>
  <div>
    <emd-alert
      variant="info"
      noClose
      :title="$t('alert')"
    />

    <emd-text
      size="medium"
      class="eu-my_4"
    >
      <b>{{ $t('title') }}</b>
    </emd-text>
    <text-section>
      <emd-text-content :title="$t('bank')">
        <b>
          <emd-text size="medium">{{ values.bank }}</emd-text>
        </b>
      </emd-text-content>
      <emd-text-content :title="$t('type')">
        <b>
          <emd-text size="medium">{{ values.type }}</emd-text>
        </b>
      </emd-text-content>
    </text-section>
    <text-section>
      <emd-text-content :title="$t('accountNumber')">
        <b>
          <emd-text size="medium">
            {{ values.accountNumber }}-{{ values.accountCheckDigit }}
          </emd-text>
        </b>
      </emd-text-content>
      <emd-text-content :title="$t('branchNumber')">
        <b>
          <emd-text
            v-if="values.branchCheckDigit"
            size="medium"
            >{{ values.branchNumber }}-{{ values.branchCheckDigit }}
          </emd-text>

          <emd-text
            v-else
            size="medium"
            >{{ values.branchNumber }}
          </emd-text>
        </b>
      </emd-text-content>
      <emd-text-content :title="$t('holderDocument')">
        <b>
          <emd-text size="medium">{{ cpfOrCnpjFormated }}</emd-text>
        </b>
      </emd-text-content>
    </text-section>

    <text-section>
      <emd-text-content
        :title="$t('holderName')"
        class="nowrap"
      >
        <b>
          <emd-text size="medium">{{ values.holderName }}</emd-text>
        </b>
      </emd-text-content>
    </text-section>

    <text-section v-if="hasRecipients">
      <emd-text-content
        :title="$t('receiver')"
        class="nowrap"
      >
        <b>
          <emd-text size="medium">{{ recipientName }}</emd-text>
        </b>
      </emd-text-content>
    </text-section>

    <text-section>
      <emd-text-content :title="$t('totalAmount')">
        <b>
          <emd-text size="medium">{{ values.totalAmount }}</emd-text>
        </b>
      </emd-text-content>
      <emd-text-content :title="$t('amount')">
        <b
          @click="$emit('edit')"
          class="eu-display_flex pointer"
        >
          <emd-text
            size="medium"
            class="emd-text edit-text"
            >{{ values.amount }}
          </emd-text>

          <emerald-icon
            icon="edit"
            class="eu-mx_2"
          />
        </b>
      </emd-text-content>
    </text-section>

    <hr class="eu-my_4" />

    <!-- TODO: mover para componente separado -->
    <form @submit.prevent="$emit('submit', password)">
      <label class="emd-label _required">{{
        $t('passwordConfirmation')
      }}</label>
      <emd-input
        :class="{ _state_error: passwordIncorrect }"
        name="password"
        type="password"
        v-model="password"
      />
      <b
        ><span
          v-if="passwordIncorrect"
          class="emd-text _size_small error eu-mt_1"
          >{{ $t('passwordIncorrect') }}</span
        ></b
      >
      <div
        v-if="$slots.default"
        class="actions eu-mt_5"
      >
        <slot />
      </div>
    </form>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import {
  EmdAlert,
  EmdTextContent,
  EmdText,
  EmdInput,
  EmeraldIcon
} from 'emerald-vue/src/components'
import { formatNumberToCpfCnpj } from '@/utils/formatCpfCnpj.utils'

import TextSection from '../components/TextSection.vue'
import ConfirmBankDetailsManager from './managers/confirm-bank-details-step.manager'

import { isAllTypeSplit } from '../enums/splits.enum'

export default {
  name: 'ConfirmBankDetailsStep',
  props: {
    initialValues: Object,
    recipient: {
      required: false,
      type: [String, Array]
    },
    passwordIncorrect: Boolean
  },
  components: {
    EmdAlert,
    EmdTextContent,
    EmdText,
    EmdInput,
    EmeraldIcon,
    TextSection
  },
  data () {
    return {
      values: {},
      password: ''
    }
  },
  validations: {
    password: {
      required
    }
  },
  computed: {
    hasRecipients () {
      return typeof this.recipient !== 'undefined'
    },
    recipientName () {
      if (isAllTypeSplit(this.recipient)) return this.$t('all')
      return this.recipient
    },
    cpfOrCnpjFormated () {
      return formatNumberToCpfCnpj(this.values.holderDocument)
    }
  },
  methods: {
    onChangePassword (value) {
      this.password = value
    }
  },
  created () {
    const transformedValues = new ConfirmBankDetailsManager(
      this.initialValues
    ).get()

    this.values = {
      ...transformedValues,
      type: this.$t(transformedValues.type)
    }
  }
}
</script>
<style scoped>
.actions {
  display: flex;
  flex-direction: row-reverse;
}

hr {
  border-top: #cdcdd0;
}
.edit-text,
.error {
  color: #a71a44;
}
.nowrap {
  text-wrap: nowrap;
}
.pointer {
  cursor: pointer;
}
</style>
<i18n>
{
   "pt-BR": {
    "alert": "Não é possível cancelar o estorno após concluir esta solicitação.",
    "title": "Confirme os dados",
    "holderName": "Nome/Razão social do favorecido",
    "type": "Tipo de conta",
    "holderDocument": "CPF/CNPJ",
    "bank": "Banco",
    "branchNumber": "Agência",
    "branchCheckDigit": "Dígito",
    "accountNumber": "Conta",
    "accountCheckDigit": "Dígito",
    "totalAmount": "Valor pago",
    "amount": "Valor a estornar",
    "passwordConfirmation": "Informe sua senha para confirmar esta solicitação",
    "all": "Manter a regra de divisão",
    "passwordIncorrect": "Senha incorreta, verifique e tente novamente. Por segurança, após 3 tentativas iremos deslogar o seu acesso.",
    "receiver": "Recebedor"
   },
   "en-US": {
    "alert": "It is not possible to cancel the refund after confirming this request",
    "title": "Confirm the data",
    "holderName": "Holder name",
    "type": "Account type",
    "holderDocument": "Holder document",
    "bank": "Bank",
    "branchNumber": "Branch number",
    "branchCheckDigit": "Digit",
    "accountNumer": "Account number",
    "accountCheckDigit": "Digit",
    "passwordConfirmation": "Inform your password to confirm this action",
    "totalAmount": "Total amount",
    "amount": "Amount to refund",
    "all": "Preserve the division rule",
    "passwordIncorrect": "The provided password is incorrect, please try again. For security, after 3 retries you will be logged out.",
    "receiver": "Receiver"
   }
}
</i18n>
